<template>
<div>
  <template>
  <v-data-table
    :headers="headers"
    :items="orders"
    class="my-5 elevation-1"
    disable-initial-sort
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <router-link class="cursor" tag="tr" :to="`/orders/${props.item.id}`">
        <td v-if="props.item.order.charge" class="text-xs-left">
          {{ props.item.order.charge | moment("dddd, MMMM Do YYYY") }},<br>
          {{ props.item.order.charge |  moment("from", "now") }}
        </td>
        <td class="text-xs-left">{{ props.item.order.contact.email.value }}</td>
        <td class="text-xs-left"><template  v-for="name in props.item.order.orders">{{name.name}},</template></td>
      </router-link>
    </template>
  </v-data-table>
</template>
</div>
</template>

<script>
import { db } from '../firebase'
export default {
  data() {
    return {
      id: '',
      orders: [],
      headers: [{
          text: 'Date',
          value: 'Date',
          align: 'left',
          sortable: true
        },
        {
          text: 'Email',
          value: 'Email',
          align: 'left',
          sortable: false
        },
        {
          text: 'Suit',
          value: 'Suit',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  methods: {
    details(id) {
      this.$router.push({name:'details',params:{id}});
    }
  },
  created() {
    let result = [];
    db.collection("orders").get().then((items) => {
      items.forEach(category => {
        let categoryData = category.data();
        categoryData.id = category.id;
        result.push(categoryData);
      });
    })
    .catch(e=>{
      console.error(`Error happended: ${e}`)
    })
    this.orders = result;
  }
}
</script>

<style>
.width{
  width:90% !important;
}
.border{
  border-top:1px solid grey;
  border-bottom:1px solid grey;
}
.cursor{
  cursor: pointer;
}
</style>
